import parse from 'html-react-parser';
import domPurify from 'dompurify';

export const getSafeHtml = html => {
  return parse(domPurify.sanitize(html || ''));
};
